
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/service/[slug]",
      function () {
        return require("private-next-pages/service/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/service/[slug]"])
      });
    }
  